module.exports = __webpack_public_path__ + "img/schema_omi_3b2.b6317e2e.svg";